module.exports = __webpack_public_path__ + "static/media/mysterious-egypt.5f0c667a.gif";